import { Check } from "@phosphor-icons/react";
import { WHY, IMAGES } from "@/data/content";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";

export const WhySection = () => (
  <section data-testid="why-section" className="relative overflow-hidden border-t border-white/10 bg-panel/40 py-24 md:py-32">
    <div className="relative mx-auto grid max-w-[1440px] gap-14 px-6 md:px-12 lg:grid-cols-[1fr_1.1fr] lg:items-center">
      <Reveal>
        <div className="mb-4 flex items-center gap-3">
          <span className="h-px w-10 bg-brand-cyan" />
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-brand-cyan">Why Genuine Forge</span>
        </div>
        <h2 className="font-display text-4xl font-extrabold leading-[0.98] tracking-tight md:text-5xl">
          The contractor serious clients trust with important systems.
        </h2>
        <p className="mt-6 max-w-lg font-body text-base leading-relaxed text-slatex-300">
          We position around competence — not coupons. Clear scope, clean workmanship, and documentation you can hand to a building owner or GC.
        </p>
        <div className="mt-10 aspect-[16/10] overflow-hidden border border-white/10">
          <img src={IMAGES.mechanicalRoom} alt="Clean mechanical room installation" className="h-full w-full object-cover" />
        </div>
      </Reveal>

      <Stagger className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2">
        {WHY.map((w) => (
          <StaggerItem key={w} className="flex items-start gap-3 bg-ink p-6">
            <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center border border-brand-cyan/40 bg-brand-cyan/10">
              <Check size={12} weight="bold" className="text-brand-cyan" />
            </span>
            <span className="font-body text-sm leading-snug text-white">{w}</span>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
  </section>
);

export default WhySection;
